
import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_ROUTES } from "../../../../routing/Routes";
import RouteCardCompanyUser from "./RouteCardCompanyUser";

const RouteCompanyUserScreen = () => (
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.RUTAS),
      url: ROUTE_COMPANY_USER_ROUTES,
      icon: AppIcon.ROUTE,
    },
  ]}>
    <RouteCardCompanyUser/>
  </ScreenCard>
);

export default RouteCompanyUserScreen;
